import {useEffect,useRef,useId,type ReactNode} from 'react';
export default function Dialog({title,children,onClose,busy=false}:{title:string;children:ReactNode;onClose:()=>void;busy?:boolean}){
  const ref=useRef<HTMLDivElement>(null),id=useId();
  useEffect(()=>{
    const active=document.activeElement as HTMLElement|null, overflow=document.body.style.overflow;
    document.body.style.overflow='hidden';ref.current?.querySelector<HTMLElement>('input,button,select,textarea')?.focus();
    return()=>{document.body.style.overflow=overflow;active?.focus();};
  },[]);
  return <div id="modal-overlay" className="open" onMouseDown={e=>{if(e.target===e.currentTarget&&!busy)onClose();}}><div id="modal-box" role="dialog" aria-modal="true" aria-labelledby={id} ref={ref} onKeyDown={e=>{
    if(e.key==='Escape'&&!busy)onClose();
    if(e.key==='Tab'){
      const elements=Array.from(ref.current?.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href]')||[]),first=elements[0],last=elements.at(-1);
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
    }
  }}><button className="modal-close" type="button" onClick={onClose} disabled={busy} aria-label="Cerrar">✕</button><h3 id={id}>{title}</h3>{children}</div></div>;
}
